import axios from "axios";

export const request = axios.create({
   baseURL: "https://kv-engine-v3-prod.onrender.com/v1"
   // baseURL: "https://staging-api.knight.ventures/"
});
